<template>
  <div style="padding: 0 !important;">
    <v-content class="body-content">
      <div v-if="loading">
        <v-flex offset-xs5 pa-5>
          <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
        </v-flex>
      </div>
      <div v-else class="ruta-container">
        <span class="mx-1"> {{ titleRoute }}</span>
        <div class="no-content-container" v-if="partidos.length === 0">
        <v-icon color="676767" large>mdi-alert</v-icon>
        <span>No hay partidos disponibles para la fecha seleccionada</span>
      </div>
      </div>
      <ListaTarjetasPartidos v-if="partidos.length > 0" :partidos="partidos" @goDetailPartido="handleGoDetail"></ListaTarjetasPartidos>

    </v-content>
  </div>
</template>

<script>
import ListaTarjetasPartidos from '../components/ListaTarjetasPartidos.vue'
export default {

  components: {
    ListaTarjetasPartidos
  },
  data () {
    return {
      partidos: [],
      loading: null
    }
  },
  props: {
    routeSelection: null,
    torneoId: null,
    fechaId: null,
    titleRoute: null
  },
  methods: {
    fetchPartidos () {
      this.axios
        .get(`informe-auditoria/partidos-info?fecha=${this.fechaId}`)
        .then(response => {
          this.partidos = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    handleGoDetail (partidoId) {
      this.$router.push({
        name: 'fichaDePartidoDetail',
        params: {
          partidoId: partidoId,
          routeSelection: {
            torneo: this.tournamentSelectionId,
            categoria: this.categorySelectionId,
            temporada: this.seasonSelectionId,
            historic: this.historicTournamentSelectionMode,
            fecha: this.fechaSelectionId
          }
        }
      })
    }
  },
  created () {
    this.$emit('selectedTorneoPath', { torneo: this.torneoId, fecha: this.fechaId })
  },
  mounted () {
    this.loading = true
    this.fetchPartidos()
  },
  watch: {
    async fechaId () {
      this.fetchPartidos()
    }
  }
}
</script>

<style scoped>
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
}

.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}

.spacing-top {
  margin-top: 5.2em !important;
}

.body-content {
  background-color: white;
  min-height: 80em;
  padding: 0 0 3em 0 !important;
  margin: 14.5em 5em 0 5em !important;
}

.selectores-container {
  margin-top: 4.8em;
  width: 100%;
}

.ruta-container {
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 1em;
  font-size: 1.6em;
  font-family: SourceSansProRegular, sans-serif;
  color: #293968;
}

.no-content-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: large;
  justify-content: center;
  align-content: center;
  color: "676767"
}

@media screen and (max-width: 1400px) {
  .body-content {
    background-color: white;
    min-height: 80em;
    padding: 0 0 3em 0 !important;
    margin: 14.5em 4em 0 4em !important;
  }
}</style>
